<div class="holder">
  @if (loading$ | async) {
    <div class="spinner-holder" [@fadeInOut]>
      <div class="spinner">
        <div class="dot1"></div>
        <div class="dot2"></div>
      </div>
    </div>
  }

  <router-outlet></router-outlet>
</div>
@if (authenticationChecked$ | async) {
  <tfs-cookie-consent></tfs-cookie-consent>
}

<tfsport-secondary-navigation class="footer"></tfsport-secondary-navigation>
